import { useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AppButton from "../../components/AppButton";
import BackArrow from "../../components/BackArrow";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  reqToGetRestaurantDetailsFromIDB,
  reqToGetRestaurantReportFromIDB,
} from "../../store/slice/indexedDBSlice";
import { routes } from "../../helpers/constants";
import { DataNotFound } from "../../components";
import { dataMessages } from "../../helpers/messages";

const Company = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { type } = location.state || {};

  useEffect(() => {
    if (!type) {
      navigate(routes.dashboard);
    }
  }, []);

  const {
    restaurantList,
    govermentMarketList,
    restaurantReportList,
    govermentMarketReportList,
    isRestaurantListIDBChecked,
    isRestaurantReportIDBChecked,
  } = useSelector(
    (state) => ({
      restaurantList: state.indexedDBReducer?.restaurantList,
      govermentMarketList: state.indexedDBReducer?.govermentMarketList,
      restaurantReportList: state.indexedDBReducer?.restaurantReportList,
      govermentMarketReportList:
        state.indexedDBReducer?.govermentMarketReportList,
      isRestaurantListIDBChecked:
        state.indexedDBReducer?.isRestaurantListIDBChecked,
      isRestaurantReportIDBChecked:
        state.indexedDBReducer?.isRestaurantReportIDBChecked,
    }),
    shallowEqual
  );

  useEffect(() => {
    if (!isRestaurantListIDBChecked && !isRestaurantReportIDBChecked) {
      dispatch(reqToGetRestaurantDetailsFromIDB({}));
      dispatch(reqToGetRestaurantReportFromIDB({}));
    } else if (!isRestaurantListIDBChecked) {
      dispatch(reqToGetRestaurantDetailsFromIDB({}));
    } else if (!isRestaurantReportIDBChecked) {
      dispatch(reqToGetRestaurantReportFromIDB({}));
    }
  }, [isRestaurantListIDBChecked, isRestaurantReportIDBChecked]);

  const reportLists = useMemo(() => {
    if (type === "cReports") {
      return restaurantReportList;
    } else if (type === "gReports") {
      return govermentMarketReportList;
    }
  }, [
    type,
    restaurantReportList,
    isRestaurantReportIDBChecked,
    govermentMarketReportList,
    isRestaurantReportIDBChecked,
  ]);

  return (
    <div className="tcl-raffles-makati-page">
      <div className="tcl-raffles-makati-wrapper">
        <BackArrow
          handleClick={() =>
            navigate(routes.dashboard, { state: { ...location.state } })
          }
        />
        <div className="tcl-personal-page">
          <div className="tcl-personal-wrapper">
            {type === "GOVERMENT" && (
              <div className="btn-wrapper">
                {!Array.isArray(govermentMarketList) ||
                govermentMarketList?.length === 0 ? (
                  <DataNotFound name={dataMessages.noRestaurant} />
                ) : (
                  govermentMarketList.map((item, index) => (
                    <AppButton
                      key={index}
                      title={item.name}
                      disabled={index !== 0}
                      onClick={() =>
                        navigate(routes.companyItemList, {
                          state: {
                            ...location.state,
                            type: type,
                            selectedRestaurant: item,
                          },
                        })
                      }
                    />
                  ))
                )}
              </div>
            )}
            {type === "COMPANY" && (
              <div className="btn-wrapper">
                {!Array.isArray(restaurantList) ||
                restaurantList?.length === 0 ? (
                  <DataNotFound name={dataMessages.noRestaurant} />
                ) : (
                  restaurantList.map((item, index) => {
                    return (
                      <AppButton
                        key={index}
                        title={item.name}
                        onClick={() =>
                          navigate(routes.companyItemList, {
                            state: {
                              ...location.state,
                              type: type,
                              selectedRestaurant: item,
                            },
                          })
                        }
                      />
                    );
                  })
                )}
              </div>
            )}
            {(type === "cReports" || type === "gReports") && (
              <div className="btn-wrapper">
                {!Array.isArray(reportLists) || reportLists?.length === 0 ? (
                  <DataNotFound name={dataMessages.noRestaurant} />
                ) : (
                  reportLists.map((item, index) => (
                    <AppButton
                      key={index}
                      title={item.name}
                      disabled={type === "gReports" && index !== 0}
                      onClick={() =>
                        navigate(routes.companyItemList, {
                          state: {
                            ...location.state,
                            type: type,
                            selectedRestaurant: item,
                          },
                        })
                      }
                    />
                  ))
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Company;
